import * as React from 'react';
import { ReduxFormContext } from 'redux-form';
import { Label } from '@gandi/ui';
import HelpMessage from '../controls/HelpMessage';
import ErrorMessage from '../controls/ErrorMessage';
import Legend from '../controls/Legend';
import Fieldset from '../controls/Fieldset';
function FormGroup(props) {
  var reduxForm = React.useContext(ReduxFormContext);
  // $FlowFixMe submitFailed IS actually in redux-form Context
  var submitFailed = reduxForm.submitFailed;
  var showError = !!props.meta.error && (props.meta.touched || submitFailed) || !!props.error;
  var renderLabel = function renderLabel() {
    if (props.legend) {
      return /*#__PURE__*/React.createElement(Legend, {
        required: props.required
      }, props.legend);
    }
    if (props.label) {
      var _props$input;
      return /*#__PURE__*/React.createElement(Label
      // $FlowFixMe[unnecessary-optional-chain]
      , {
        target: props.id || ((_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.name),
        popoverIcon: props.popoverIcon,
        required: props.required,
        disabled: props.disabled
      }, props.label);
    }
    return null;
  };
  return (
    /*#__PURE__*/
    // $FlowFixMe[prop-missing]
    // $FlowFixMe[incompatible-return]
    React.createElement(Fieldset, {
      error: showError
    }, renderLabel(), props.children, showError && /*#__PURE__*/React.createElement(ErrorMessage, {
      text: props.meta.error || props.error
    }), props.meta.warning && /*#__PURE__*/React.createElement(HelpMessage, {
      text: props.meta.warning
    }), props.help && /*#__PURE__*/React.createElement(HelpMessage, {
      text: props.help
    }))
  );
}
export default FormGroup;